import Api_Usermanagement from '../../api-usermanagement'

const api = new Api_Usermanagement().init()

const getAll = (sales, module, create, update, lang) => {
  return api.get(
    `/config/date-config/payment-due-date?credentials=${localStorage.getItem(
      'credential'
    )}&sales_org_code=${sales}&module=${module}&created_at=${create}&updated_at=${update}&lang=${lang}`,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
        apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
        Accept: 'application/json',
        'Access-Control-Allow-Origin': '*',
      },
    }
  )
}

const getDetail = (id) => {
  return api.get(`/config/date-config/payment-due-date/${id}?credentials=${localStorage.getItem('credential')}`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const createNew = (data) => {
  return api.post(
    `/config/date-config/payment-due-date?credentials=${localStorage.getItem('credential')}`,
    data,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
        apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
        Accept: 'application/json',
        'Access-Control-Allow-Origin': '*',
      },
    }
  )
}

const updateById = (id, data) => {
  return api.put(
    `/config/date-config/payment-due-date/${id}?credentials=${localStorage.getItem('credential')}`,
    data,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
        apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
        Accept: 'application/json',
        'Access-Control-Allow-Origin': '*',
      },
    }
  )
}

const deleteById = (id) => {
  return api.delete(
    `/config/date-config/${id}?credentials=${localStorage.getItem('credential')}`,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
        apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
        Accept: 'application/json',
        'Access-Control-Allow-Origin': '*',
      },
    }
  )
}

const getForModule = (payload) => {
  const params = new URLSearchParams(payload).toString()
  return api.get(`/config/date-config/payment-due-date/get-for-module?` + params, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

export {getAll, getDetail, createNew, updateById, deleteById, getForModule}
